<template>
  <v-switch
    @change="val => $emit('input', Boolean(val))"
    class="vcita-switch"
    :class="{
      'is-active': $attrs.value,
    }"
    :input-value="$attrs.value"
    v-bind="$attrs"
    v-on="$listeners"
    :color="brandBgColor"
    :hide-details="'auto'"
    inset/>
</template>

<script>
    export default {
      name: "VcitaSwitch",

      computed: {
        brandBgColor() {
          return this.$store && this.$store.getters['brandModule/secondaryColor'];
        },
      }
    }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .vcita-switch {
    font-family: var(--primary-font-family);
    padding: 0;
    margin: 0;
    ::v-deep {
      label {
        font-family: var(--primary-font-family);
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        color: rgba(0,0,0,0.87);
      }
      input {
        height: 20px;
      }
      .v-input--selection-controls__input {
        @include i-margin-mirror(0, 12px);
        height: 20px;
        width: 34px;
      }

        .v-input--switch__track {
            top: 0;
            background-color: #D6DBE6;
            opacity: 1;
            border-radius: 29px;
            @include i-position-mirror(left, 0);
            height: 20px;
            width: 34px;
        }
      .v-input--selection-controls__ripple {
        top: calc(50% - 20px);
        @include i-position-mirror(left, -10px);
        height: 25px;
        width: 25px;
      }
      .v-input--switch__thumb {
        height: 14px;
        width: 14px;
        background-color: #fff;
        top: calc(50% - 7px);
        @include i-translate-x(3px, '!');
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.141176), 0 1px 3px rgba(0, 0, 0, 0.2);
      }
    }
    &.is-active {
      ::v-deep {
        .v-input--switch__track {
          opacity: 1;
          background-color: currentColor;
        }
        .v-input--selection-controls__ripple {
          @include i-translate-x(14px, '!');
        }
        .v-input--switch__thumb {
          @include i-translate-x(17px, '!');
        }
      }
    }
  }

</style>
